import { BaseModel } from '../../_base/crud';

export class PatientWeightModel extends BaseModel {
  id: number;
  patientId: number;
  weight: number;
  start_date: string;
  is_active: boolean;
  _isEditMode: boolean;

  clear(patientId) {
    this.id = 0;
    this.patientId = patientId;
    this.weight = 0;
    this.start_date = '';
    this.is_active = false;
    this._isEditMode = false;
  }
}
